import React, {Component} from 'react';
import moment from 'moment';
import Ry from 'ryvendor/Ry/Core/Ry';
import trans from '../../../../app/translations';
import Modelizer from 'ryvendor/Ry/Core/Modelizer';
import Localtime from './Localtime';
import {Popup, PopupBody, PopupHeader} from 'ryvendor/bs/bootstrap';
import $ from 'jquery';
import numeral from "numeral";

export class Route extends Component
{
    render() {
        return this.props.data.nsetup.transports.map(transport=><React.Fragment key={`transport-${transport.conveyence_reference}`}>
            <li>{trans('Départ')}<br/>
    <strong className="text-wrap">{transport.departure_location.country.nom} - {transport.departure_location.iata} - {transport.departure_location.name} {trans('le')} {moment(transport.departure_datetime_lt).format('DD/MM/YYYY HH:mm')}{(this.models('props.data.nsetup.transports.'+this.props.transportStep+'.departure_datetime_lt', false) && this.models('props.data.nsetup.transports.'+this.props.transportStep+'.departure_datetime_lt', false)!=transport.departure_datetime_lt)?<React.Fragment> - <span className="text-danger">{trans('Horaire modifié : :datetime', {datetime : moment(this.models('props.data.transports.'+this.props.transportStep+'.departure_datetime_lt')).format('DD/MM/YYYY HH:mm')})}</span></React.Fragment>:null}</strong></li>
            <li>{trans('Arrivée')}<br/>
            <strong className="text-wrap">{this.cast(transport, 'arrival_location.country.nom', this.cast(transport, 'arrival_location.adresse.ville.country.nom'))} - {this.cast(transport, 'arrival_location.iata', this.cast(transport, 'arrival_location.cardit'))} - {this.cast(transport, 'arrival_location.name')} {trans('le')} {transport.arrival_datetime_lt!='0000-00-00 00:00:00'?moment(transport.arrival_datetime_lt).format('DD/MM/YYYY HH:mm'):'00/00/00 00:00'}{(this.models('props.data.nsetup.transports.'+this.props.transportStep+'.arrival_datetime_lt', false) && this.models('props.data.nsetup.transports.'+this.props.transportStep+'.arrival_datetime_lt', false)!=transport.arrival_datetime_lt)?<React.Fragment> - <span className="text-danger">{trans('Horaire modifié : :datetime', {datetime : moment(this.models('props.data.transports.'+this.props.transportStep+'.arrival_datetime_lt')).format('DD/MM/YYYY HH:mm')})}</span></React.Fragment>:null}</strong></li>
        </React.Fragment>)
    }
}

Modelizer(Route)

class ReceptacleLine extends Component
{
    constructor(props) {
        super(props)
        this.state = {
            cn35PdfLoading: false
        }
        this.isMld = this.models('props.data.nsetup.poc.value', false)
        this.transitTreated = this.models('props.data.nsetup.transit_treated', '')
        this.scan = this.scan.bind(this)
    }


    loadJsPdf() {
        if (window.jspdf && window.jspdf.jsPDF) {
            return Promise.resolve(window.jspdf.jsPDF);
        }

        if (window.__cn35JsPdfPromise) {
            return window.__cn35JsPdfPromise;
        }

        window.__cn35JsPdfPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            script.async = true;
            script.onload = () => {
                if (window.jspdf && window.jspdf.jsPDF) {
                    resolve(window.jspdf.jsPDF);
                } else {
                    reject(new Error('jsPDF CDN loaded but jsPDF is unavailable.'));
                }
            };
            script.onerror = () => reject(new Error('Unable to load jsPDF from CDN.'));
            document.head.appendChild(script);
        });

        return window.__cn35JsPdfPromise;
    }

    cn35Value(paths, fallback = '') {
        for (let i = 0; i < paths.length; i++) {
            const path = paths[i].split('.');
            let value = this.props.data;

            for (let j = 0; j < path.length; j++) {
                if (value == null) break;
                value = value[path[j]];
            }

            if (value !== undefined && value !== null && value !== '') {
                return value;
            }
        }

        return fallback;
    }

    cn35ImpcByCode(code) {
        const impcs = this.props.impcs || [];
        return impcs.find(impc => impc && impc.code === code) || null;
    }

    cn35OriginImpc() {
        const receptacleId = this.cn35Value(['nsetup.receptacle_id'], '');
        return this.cn35ImpcByCode(String(receptacleId).substring(0, 6));
    }

    cn35DestinationImpc() {
        const receptacleId = this.cn35Value(['nsetup.receptacle_id'], '');
        return this.cn35ImpcByCode(String(receptacleId).substring(6, 12));
    }

    cn35ImpcCode(impc) {
        if (!impc) return '';
        const name12 = impc.name12 || '';
        const code3 = impc.code3 || '';
        if (!name12 && !code3) return '';
        return `${name12}${code3 ? ` (${code3})` : ''}`;
    }

    cn35ImpcName(impc) {
        return impc && impc.name12 ? impc.name12 : '';
    }

    cn35OperatorName(impc) {
        return impc && impc.organisation_name12 ? impc.organisation_name12 : '';
    }

    cn35FormattedReceptacleId() {
        const receptacleId = String(this.cn35Value(['nsetup.receptacle_id'], ''));
        if (!receptacleId) return '';

        return `${receptacleId.substring(0, 6)} ` +
            `${receptacleId.substring(6, 12)} ` +
            `${receptacleId.substring(12, 15)} ` +
            `${receptacleId.substring(15, 16)} ` +
            `${receptacleId.substring(16, 20)} ` +
            `${receptacleId.substring(20, 23)} ` +
            `${receptacleId.substring(23, 25)} ` +
            `${receptacleId.substring(25, 29)}`;
    }

    cn35SpecialContentCode() {
        const receptacleId = String(this.cn35Value(['nsetup.receptacle_id'], ''));
        return receptacleId.charAt(24) === '1' ? 'V' : '';
    }

    cn35DispatchDocumentationIndicator() {
        const receptacleId = String(this.cn35Value(['nsetup.receptacle_id'], ''));
        return receptacleId.charAt(23) === '1' ? 'F' : '';
    }

    cn35ProductionData() {
        return 'printed by SupairData system';
    }

    cn35TransportInformation() {
        const transports = this.models('props.data.carditnsetup.transports', []);
        if (!Array.isArray(transports) || transports.length === 0) return '';

        return transports.map(transport => {
            const day = transport && transport.departure_datetime
                ? moment(transport.departure_datetime).format('D')
                : '';
            const departureIata = transport && transport.departure_location
                ? transport.departure_location.iata || ''
                : '';
            const conveyenceReference = transport && transport.conveyence_reference
                ? transport.conveyence_reference
                : '';
            const arrivalIata = transport && transport.arrival_location
                ? transport.arrival_location.iata || ''
                : '';

            return [day, departureIata, conveyenceReference, arrivalIata]
                .filter(value => value !== '')
                .join(' ');
        }).join('\n');
    }

    cn35BorderStyle(borders) {
        const edges = borders || '';
        const has = edge => edges.indexOf(edge) !== -1;
        return {
            borderTop: has('T') ? '0.35mm solid #000' : 'none',
            borderLeft: has('L') ? '0.35mm solid #000' : 'none',
            borderBottom: has('B') ? '0.35mm solid #000' : 'none',
            borderRight: has('R') ? '0.35mm solid #000' : 'none'
        };
    }

    cn35Cell(code, fontSize, left, top, width, height, value, align, fontWeight, borders, title = '', valueTop = null, valueLeft = null, valueRight = null) {
        const borderStyle = this.cn35BorderStyle(borders);
        const fontStyle = (fontWeight === 'I' || fontWeight === '/') ? 'italic' : 'normal';
        const fontWeightCss = fontWeight === 'B' ? 700 : 400;

        const textAlign = align === 'L' ? 'left' : (align === 'R' ? 'right' : 'center');
        const defaultValueTop = title ? 3.0 : 0;

        const valueStyle = {
            position: 'absolute',
            top: `${valueTop !== null ? valueTop : defaultValueTop}mm`,
            left: valueLeft !== null ? `${valueLeft}mm` : '0.5mm',
            right: valueRight !== null ? `${valueRight}mm` : '0.5mm',
            fontSize: fontSize,
            fontWeight: fontWeightCss,
            fontStyle: fontStyle,
            lineHeight: '1',
            textAlign: textAlign,
            whiteSpace: value && String(value).indexOf('\n') !== -1 ? 'pre-line' : 'nowrap'
        };

        const style = {
            position: 'absolute',
            left: `${left}mm`,
            top: `${top}mm`,
            width: `${width}mm`,
            height: `${height}mm`,
            boxSizing: 'border-box',
            ...borderStyle,
            color: '#000',
            background: '#fff',
            overflow: 'hidden',
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontStyle: fontStyle
        };

        return (
            <div key={code} style={style} data-cn35-zone={code}>
                {title ? <div style={{
                    position: 'absolute',
                    top: '0.5mm',
                    left: '0.5mm',
                    right: '0.5mm',
                    fontSize: '1.76mm',
                    lineHeight: '1',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    textAlign: 'left',
                    whiteSpace: 'nowrap'
                }}>{title}</div> : null}

                <div style={valueStyle}>{value}</div>
            </div>
        );
    }

    async generateCn35Pdf() {
        if (this.state.cn35PdfLoading) {
            return;
        }

        this.setState({ cn35PdfLoading: true });

        try {
            const receptacleId = this.cn35Value(['nsetup.receptacle_id'], '');
            const jsPDF = await this.loadJsPdf();

            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: [130, 90],
                compress: true
            });

            pdf.setProperties({
                title: `CN35 ${receptacleId}`,
                subject: 'CN35 Postal Receptacle Label'
            });

            const borderWidth = 0.35;
            const fontMmToPt = mm => mm / 0.3527777778;
            const alignMap = { L: 'left', C: 'center', R: 'right' };
            const weightMap = { B: 'bold', I: 'italic', '/': 'italic', N: 'normal' };

            const text = (value, x, y, sizeMm, align = 'L', weight = 'N', fallback = '') => {
                const safeValue = value == null || value === '' ? fallback : String(value);
                pdf.setTextColor(0, 0, 0);
                pdf.setFont('helvetica', weightMap[weight] || 'normal');
                pdf.setFontSize(fontMmToPt(sizeMm));
                pdf.text(safeValue, x, y, { align: alignMap[align] || 'left' });
            };

            const drawBorders = (x, y, w, h, borders = '') => {
                pdf.setDrawColor(0, 0, 0);
                pdf.setLineWidth(borderWidth);

                if (borders.indexOf('T') !== -1) {
                    pdf.line(x, y, x + w, y);
                }

                if (borders.indexOf('L') !== -1) {
                    pdf.line(x, y, x, y + h);
                }

                if (borders.indexOf('B') !== -1) {
                    pdf.line(x, y + h, x + w, y + h);
                }

                if (borders.indexOf('R') !== -1) {
                    pdf.line(x + w, y, x + w, y + h);
                }
            };

            const label = (value, x, y, w, h, sizeMm, align = 'L', weight = 'N', borders = '', title = '', fallback = '', titleFontSize = 1.76, valueOffsetX = 0, valueOffsetY = null, titleWeight = 'N') => {
                drawBorders(x, y, w, h, borders);

                if (title) {
                    text(title, x + 0.8, y + 2.0, titleFontSize, 'L', titleWeight, '');
                }

                let textX = x + 0.8 + valueOffsetX;

                if (align === 'C') {
                    textX = x + w / 2 + valueOffsetX;
                }

                if (align === 'R') {
                    textX = x + w - 0.8 + valueOffsetX;
                }

                const textY = valueOffsetY !== null ? y + valueOffsetY : title ? y + h - 1.4 : y + (h / 2) + (sizeMm / 2.8);
                text(value, textX, textY, sizeMm, align, weight, fallback);
            };

            const X = 2;
            const Y = 3;

            const originImpc = this.cn35OriginImpc();
            const destinationImpc = this.cn35DestinationImpc();
            const formattedReceptacleId = this.cn35FormattedReceptacleId();
            const specialContentCode = this.cn35SpecialContentCode();
            const dispatchDocumentationIndicator = this.cn35DispatchDocumentationIndicator();
            const productionData = this.cn35ProductionData();
            const transportInformation = this.cn35TransportInformation();

            // A
            label(this.cn35Value([], ''), X + 0, Y + 0, 42, 6, 2.3, 'L', 'B', 'B');
            label(this.cn35ImpcCode(originImpc), X + 0, Y + 6, 42, 5, 3.0, 'L', 'N', '', trans('De'), '', 1.76, 4, 4.0);
            label(this.cn35ImpcName(originImpc), X + 0, Y + 11, 42, 5, 3.0, 'L', 'N', '');
            label(this.cn35OperatorName(originImpc), X + 0, Y + 16, 42, 6, 3.0, 'L', 'N', 'B');
            label(String(this.cn35Value(['nsetup.receptacle_id'])).substr(12, 3), X + 0, Y + 24, 21, 6, 3.2, 'R', 'B', 'BR', trans('Type dép.'));
            label(Number(String(this.cn35Value(['nsetup.receptacle_id'])).substr(16, 4)), X + 21, Y + 24, 21, 6, 3.2, 'R', 'B', 'B', trans('N° dép.'));
            label(String(this.cn35Value(['carditnsetup.preparation_datetime'])).substr(0, 10), X + 0, Y + 30, 42, 6, 2.7, 'R', 'N', 'B', trans('Date'));
            label(this.cn35Value(['nsetup.type.code'], ''), X + 0, Y + 36, 21, 6, 3.2, 'R', 'N', 'R', trans('Type réc.'));
            label(Number(String(this.cn35Value(['nsetup.receptacle_id'])).substr(20, 3)), X + 21, Y + 36, 21, 6, 3.2, 'R', 'N', '', trans('N° réc.'));

            // B
            label('', X + 0, Y + 42, 21, 9, 1.6, 'L', 'N', 'BR', trans('Scellé'));
            label('', X + 21, Y + 42, 21, 9, 2.7, 'C', 'B', 'B');
            label(String(this.cn35Value(['nsetup.receptacle_id'])).substr(13, 2), X + 0, Y + 51, 21, 6, 3.2, 'R', 'N', 'BR', trans('Sous-cl. réc.'));
            label(this.cn35Value(['nsetup.item_count', 'nsetup.items_count'], ''), X + 21, Y + 51, 21, 6, 3.2, 'R', 'N', 'B', trans('Nb. d’envois'));
            label(this.cn35Value(['nsetup.gross_weight', 'nsetup.weight'], ''), X + 0, Y + 57, 21, 6, 3.2, 'R', 'B', 'BR', trans('Kg brut'));
            label(this.cn35Value(['nsetup.net_weight', 'nsetup.weight'], ''), X + 21, Y + 57, 21, 6, 2.7, 'R', 'B', 'B', trans('Kg net'));
            label('', X + 0, Y + 63, 42, 21, 2.3, 'L', 'N', '');
            label(productionData, X + 0.5, Y + 80.7, 41, 3, 1.76, 'R', 'B', '', trans('Données prod.'), '', 1.76, 0, 2.0, 'I');
            label('', X + 35, Y + 84, 7, 3, 3.0, 'C', 'N', '');

            // C
            label(this.cn35Value([], 'Airmail'), X + 42, Y + 0, 50, 12, 2.5, 'L', 'B', 'B', '', '', 2);
            label(this.cn35Value([], 'CN 35'), X + 110, Y + 0, 16, 12, 3.5, 'R', 'B', '', '', '', 2);
            label(this.cn35Value([], ''), X + 42, Y + 12, 56, 12, 2.7, 'L', 'B', 'B');
            label(specialContentCode, X + 115, Y + 11.5, 8, 12, 3.0, 'C', 'B', '');
            label(dispatchDocumentationIndicator, X + 120, Y + 9, 8, 15, 6.0, 'C', 'B', '');

            // D
            label(this.cn35ImpcCode(destinationImpc), X + 42, Y + 25, 84, 5, 3.5, 'C', 'B', '', trans('Pour'));
            label(this.cn35ImpcName(destinationImpc), X + 42, Y + 30, 84, 5, 3.5, 'C', 'B', '');
            label(this.cn35OperatorName(destinationImpc), X + 42, Y + 35, 84, 5, 3.5, 'C', 'B', '');

            // E
            label('', X + 42, Y + 42, 84, 3, 2.3, 'C', 'N', '', trans('ID récipient'));
            label(formattedReceptacleId, X + 42, Y + 59.5, 84, 6, 2.3, 'C', 'N', '');

            // F
            label(transportInformation, X + 42, Y + 66, 58, 18, 3.0, 'L', 'N', 'R', trans('Date Transport'), '', 1.76, 6.5, 8.0);
            label(this.cn35Value(['carditnsetup.handover_destination_location.iata'], ''), X + 100, Y + 66, 26, 18, 7.0, 'C', 'B', '', trans('Débarquement'), '', 1.76, 0, 12.5);

            // Bordures principales
            drawBorders(X, Y, 42, 42, 'LBR');
            drawBorders(X, Y + 42, 42, 42, 'LR');
            drawBorders(X + 42, Y, 84, 24, 'B');
            drawBorders(X + 42, Y + 24, 84, 18, 'B');
            drawBorders(X + 42, Y + 42, 84, 24, 'B');

            // Barcode
            const barcode = new Image();

            barcode.src = `/barcode?code=${encodeURIComponent(receptacleId)}`;

            await new Promise((resolve, reject) => {
                barcode.onload = resolve;
                barcode.onerror = reject;
            });

            pdf.addImage(barcode, 'PNG', X + 44, Y + 46, 80, 14, undefined, 'FAST');

            pdf.save(`CN35_${receptacleId || this.props.data.id}.pdf`);
        } finally {
            this.setState({ cn35PdfLoading: false });
        }
    }

    scan(consignment_event) {
        const disableMrd = (this.isMld && !this.props.data.nsetup.reference_receptacle_id) ? {disabled:true} : {}
        let resdit = null

        if(this.isMld && (consignment_event.code==74 || consignment_event.code==43)) {
            resdit = <div className="btn btn-xs btn-rose">MLD {moment(this.models('props.data.nsetup.poc.updated_at')).format('DD/MM')}</div>
        } else if(this.transitTreated == 1 && consignment_event.code==100)
        {
            resdit = <div className="btn btn-xs btn-rose ">MLD {(this.props.data.nsetup.poc.mldsent_at) ? moment(this.models('props.data.nsetup.poc.mldsent_at', '')).format('DD/MM') : ''}</div>
        }
        else {
            resdit = <label className="fancy-radio m-auto custom-color-green">
                <input name={`receptacles[${this.props.data.id}][nsetup][poc][value]`} type="radio" {...disableMrd} value={consignment_event.code} checked={this.models('props.data.nsetup.poc.value', -1)==consignment_event.code} onChange={()=>this.props.handleReceptacleStatusChange(consignment_event.code)}/>
                <span><i className="mr-0"></i></span>
            </label>
        }
        return resdit
    }

    render() {
        let classNames = [] 
        if((this.isMrd || this.isMld) && !this.props.data.nsetup.reference_receptacle_id)
            classNames.push('bg-stone')
        else if(this.props.data.nsetup.reference_receptacle_id)
            classNames.push('row-danger')
        else if(this.props.data.nsetup.reference_receptacle_added)
            classNames.push('row-success')
        return <tr className={classNames.join(' ')}>
        <td className="text-left">
            {this.props.data.nsetup.receptacle_id} <React.Fragment><a href={`#barcode?code=${this.props.data.nsetup.receptacle_id}`} onClick={()=>$(`#receptacle${this.props.data.nsetup.receptacle_id}`).modal('show')}><i className="fa fa-barcode"></i></a>
            <Popup id={`receptacle${this.props.data.nsetup.receptacle_id}`} className="modal-xl">
                <PopupBody>
                    <div style={{ background: '#f4f4f4', padding: '20px', overflow: 'auto' }}>
                        <div style={{ minWidth: '1000px', minHeight: '620px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div
                                id={`cn35_label_${this.props.data.id}`}
                                style={{
                                    width: '130mm',
                                    height: '90mm',
                                    minWidth: '130mm',
                                    minHeight: '90mm',
                                    position: 'relative',
                                    background: '#fff',
                                    color: '#000',
                                    fontFamily: 'Arial, Helvetica, sans-serif',
                                    boxSizing: 'border-box',
                                    boxShadow: '0 2px 12px rgba(0,0,0,.20)',
                                    transform: 'scale(1.8)',
                                    transformOrigin: 'center center'
                                }}
                            >
                                {/* Net printing area: 126 x 84 mm, 2 mm left/right and 3 mm top/bottom */}
                                <div style={{ position: 'absolute', left: '2mm', top: '3mm', width: '126mm', height: '84mm' }}>
                                    {this.cn35Cell('A0', '2.3mm', 0, 0, 42, 6, this.cn35Value([], ''), 'L', 'B', 'B')}
                                    {this.cn35Cell('A1', '3mm', 0, 6, 42, 6, this.cn35ImpcCode(this.cn35OriginImpc()), 'L', 'N', '', trans('De'), 1, 5.5, 0.5)}
                                    {this.cn35Cell('A2', '3mm', 0, 13, 49, 6, this.cn35ImpcName(this.cn35OriginImpc()), 'L', 'N', '')}
                                    {this.cn35Cell('A3', '3mm', 0, 18, 42, 6, this.cn35OperatorName(this.cn35OriginImpc()), 'L', 'N', 'B')}
                                    {this.cn35Cell('A4', '3.2mm', 0, 24, 21, 6, String(this.cn35Value(['nsetup.receptacle_id'])).substr(12, 3), 'R', 'B', 'BR', trans('Type dép.'))}
                                    {this.cn35Cell('A5', '3.2mm', 21, 24, 21, 6, Number(String(this.cn35Value(['nsetup.receptacle_id'])).substr(16, 4)), 'R', 'B', 'B', trans('N° dép.'))}
                                    {this.cn35Cell('A6', '2.7mm', 0, 30, 42, 6, String(this.cn35Value(['carditnsetup.preparation_datetime'])).substr(0, 10), 'R', 'N', 'B', trans('Date'))}
                                    {this.cn35Cell('A7', '3.2mm', 0, 36, 21, 6, this.cn35Value(['nsetup.type.code'], ''), 'R', 'N', 'R', trans('Type réc.'), 2.5)}
                                    {this.cn35Cell('A8', '3.2mm', 21, 36, 21, 6, Number(String(this.cn35Value(['nsetup.receptacle_id'])).substr(20, 3)), 'R', 'N', '', trans('N° réc.'), 2.5)}

                                    {this.cn35Cell('B0', '1.6mm', 0, 42, 21, 9, this.cn35Value([], ''), 'L', 'N', 'BR', trans('Scellé'))}
                                    {this.cn35Cell('B1', '2.7mm', 21, 42, 21, 9, this.cn35Value([], ''), 'C', 'B', 'B', '')}
                                    {this.cn35Cell('B2', '3.2mm', 0, 51, 21, 6, String(this.cn35Value(['nsetup.receptacle_id'])).substr(13, 2), 'R', 'N', 'BR', trans('Sous-cl. réc.'))}
                                    {this.cn35Cell('B3', '3.2mm', 21, 51, 21, 6, this.cn35Value(['nsetup.item_count', 'nsetup.items_count'], ''), 'R', 'N', 'B', trans('Nb. d’envois'))}
                                    {this.cn35Cell('B4', '3.2mm', 0, 57, 21, 6, this.cn35Value(['nsetup.gross_weight', 'nsetup.weight'], ''), 'R', 'B', 'BR', trans('Kg brut'), 2.5)}
                                    {this.cn35Cell('B5', '2.7mm', 21, 57, 21, 6, this.cn35Value(['nsetup.net_weight', 'nsetup.weight'], ''), 'R', 'B', 'B', trans('Kg net'))}
                                    {this.cn35Cell('B6', '2.3mm', 0, 63, 42, 21, this.cn35Value([], ''), 'L', 'N', '', '')}
                                    {this.cn35Cell('B7', '1.76mm', 0.5, 80, 40, 3, this.cn35ProductionData(), 'C', 'B', '', trans('Données prod.'), 0.5, 15, 0)}
                                    {this.cn35Cell('B8', '3mm', 35, 84, 7, 3, '', 'C', 'N', '', '')}

                                    {this.cn35Cell('C0', '2.5mm', 42, 0, 50, 12, this.cn35Value([], 'Airmail'), 'L', 'B', 'B', '', 2)}
                                    {this.cn35Cell('C2', '3.5mm', 110, 0, 16, 12, this.cn35Value([], 'CN 35'), 'R', 'B', 'N', '', 2)}
                                    {this.cn35Cell('C3', '2.7mm', 42, 12, 56, 12, this.cn35Value([], ''), 'L', 'B', 'B', '')}
                                    {this.cn35Cell('C4', '3mm', 115, 11.5, 8, 12, this.cn35SpecialContentCode(), 'C', 'B', '', '')}
                                    {this.cn35Cell('C5', '6mm', 120, 9, 8, 15, this.cn35DispatchDocumentationIndicator(), 'C', 'B', '', '')}

                                    {this.cn35Cell('D0', '3.5mm', 42, 25, 84, 6, this.cn35ImpcCode(this.cn35DestinationImpc()), 'C', 'B', '', trans('Pour'))}
                                    {this.cn35Cell('D1', '3.5mm', 42, 32, 84, 6, this.cn35ImpcName(this.cn35DestinationImpc()), 'C', 'B', '', '')}
                                    {this.cn35Cell('D2', '3.5mm', 42, 36, 84, 6, this.cn35OperatorName(this.cn35DestinationImpc()), 'C', 'B', 'B', '')}

                                    {this.cn35Cell('E0', '2.3mm', 42, 42, 84, 3, '', 'C', 'N', '', trans('ID récipient'))}
                                    {this.cn35Cell('E1', '2.3mm', 42, 61, 84, 6, this.cn35FormattedReceptacleId(), 'C', 'N', '', '')}

                                    {this.cn35Cell('F0', '3mm', 42, 66, 58, 18, this.cn35TransportInformation(), 'L', 'N', 'R', trans('Date Transport'), 5, 10, 0.5)}
                                    {this.cn35Cell('F1', '7mm', 100, 66, 26, 18, this.cn35Value(['carditnsetup.handover_destination_location.iata'], ''), 'C', 'B', '', trans('Débarquement'), 7)}

                                    <div style={{ position: 'absolute', left: '0mm', top: '0mm', width: '42mm', height: '42mm', borderLeft: '0.35mm solid #000', borderBottom: '0.35mm solid #000', borderRight: '0.35mm solid #000', pointerEvents: 'none' }}></div>
                                    <div style={{ position: 'absolute', left: '0mm', top: '42mm', width: '42mm', height: '42mm', borderLeft: '0.35mm solid #000', borderRight: '0.35mm solid #000', pointerEvents: 'none' }}></div>
                                    <div style={{ position: 'absolute', left: '42mm', top: '0mm', width: '84mm', height: '24mm', borderBottom: '0.35mm solid #000', pointerEvents: 'none' }}></div>
                                    <div style={{ position: 'absolute', left: '42mm', top: '24mm', width: '84mm', height: '18mm', borderBottom: '0.35mm solid #000', pointerEvents: 'none' }}></div>
                                    <div style={{ position: 'absolute', left: '42mm', top: '42mm', width: '84mm', height: '24mm', borderBottom: '0.35mm solid #000', pointerEvents: 'none' }}></div>

                                    <img src={`/barcode?code=${encodeURIComponent(this.props.data.nsetup.receptacle_id)}`} alt={this.props.data.nsetup.receptacle_id} style={{ position: 'absolute', left: '44mm', top: '46mm', width: '80mm', height: '14mm', objectFit: 'contain', background: '#fff' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => this.generateCn35Pdf()}
                            disabled={this.state.cn35PdfLoading}
                            style={{ height: 40, width: 200 }}
                        >
                            {this.state.cn35PdfLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                            ) : (
                                <React.Fragment>
                                    {trans('Télécharger')}<i className="fa fa-download ml-2"></i>
                                </React.Fragment>
                            )}
                        </button>
                    </div>
                </PopupBody>
            </Popup>
            </React.Fragment>

            {this.models('props.data.fhl.id')?<a href={`#dialog/fhl?id=${this.models('props.data.fhl.id')}`} className="p-1 rounded-circle bg-aqua">[FHL]</a>:null}
        </td>
        <td>{this.props.messageFunction}</td>
        <td>{this.props.data.nsetup.nesting}</td>
        <td>{this.models('props.data.nsetup.uld_out', '')}</td>
        <td>{this.models('props.data.nsetup.type.interpretation', '--')}</td>
        <td>{this.props.messageFunction==1?0:numeral(parseFloat(this.props.data.nsetup.weight)).format('0,0.0')}</td>
        {this.props.consignmentEvents.map(consignment_event=><td key={`consignment_event-check-${this.props.data.id}-${consignment_event.code}`} className="text-center">
        {this.scan(consignment_event)}
        </td>)}
    </tr>
    }
}

Modelizer(ReceptacleLine);

class Reception extends Component
{
    constructor(props) {
        super(props)
        this.state = {
            receptacles : this.props.data.receptacles,
            dialogs : [{}],
            dirty: false,
            showModal: true,
            alltreated: false
        }
        this.handleReceptacleStatusChange = this.handleReceptacleStatusChange.bind(this)
        this.handleAllReceptacleStatusChange = this.handleAllReceptacleStatusChange.bind(this)
        this.selectUld = this.selectUld.bind(this)
        console.log('RECEPTION RY VENDOR')
        console.log(this.props)
    }

    selectUld() {
        $(`#select-uld-${this.props.data.id}`).modal('show')
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    componentDidMount() {
        this.unsubscribe = this.props.store.subscribe(()=>{
            const storeState = this.props.store.getState()
            if(storeState.type=='scan' && storeState.reception && storeState.reception.length>0 && storeState.reception[0].cardit_id==this.props.data.id) {
                this.setState(state => {
                    state.dialogs.push({})
                    return state
                })
            }
            if(storeState.type==='mld_sent') {
                setTimeout(()=>{
                    document.location.reload()
                }, 1000)
            }
        })
        let treatedreceptacles = 0;
        this.state.receptacles.map(receptacle=> {
            if(receptacle.nsetup.hasOwnProperty('transit_treated'))
            {
                if(receptacle.nsetup.transit_treated == 1)
                {
                    treatedreceptacles++
                }
            }
        });

        if(treatedreceptacles == this.state.receptacles.length)
        {
            this.setState(state => {
                state.alltreated = true
                return state
            })
        }
    }

    handleReceptacleStatusChange(receptacle, status) {
        let toshow = true
        if(status == 100)
        {
            toshow = false
        }
        this.setState(state=>{
            state.dirty = true
            const _receptacle = state.receptacles.find(it=>it.id == receptacle.id)
            state.dirty = true
            _receptacle.nsetup.poc = {
                value : status
            }
            return state
        })
    }

    handleAllReceptacleStatusChange(status) {
        let toshow = true
        if(status == 100)
        {
            toshow = false
        }
        this.setState(state=>{
            state.dirty = true
            state.showModal = toshow
            state.receptacles.map(it=>{
                it.nsetup.poc = {
                    value : status
                }
            })
            return state
        })
    }

    render() {
        let mailclass_concat = Object.keys(this.models('props.data.nsetup.mail_classes', {})).join('')
        let scannedBags = this.models('props.data.receptacles', []).filter(item=>this.cast(item, 'nsetup.poc.value'))
        let numberScannedBags = scannedBags.length
        let weightScannedBags= scannedBags.reduce((acc, item) => acc + parseFloat(this.cast(item, 'nsetup.weight')), 0)
        if(!mailclass_concat)
            mailclass_concat = this.models('props.data.nsetup.mail_class.code')
        return <div className="row">
            <div className="col-md-12 d-md-block d-xl-none">
                <div className="row text-left text-body">
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <small className="text-muted">{trans('Numéro du container')} :</small><br/>
                                {this.props.data.nsetup.container_id}
                            </div>
                            <div className="col-md-6">
                                <small className="text-muted">{trans('Nombre de récipient')} :</small><br/>
                                {this.props.data.nsetup.nreceptacles}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        
                    </div>
                </div>
            </div>
            <div className="col-xl-3 d-md-none d-xl-block">
                <div className="blockTemps">
                    <ul className="info">
                        <li>
                            {this.models('props.data.nsetup.consignment_category.code')=='A'?<a href={trans('/cn38?id=:id', {id:this.props.data.id})} target="_blank" className="btn btn-beige w-25 text-light">CN 38</a>
                            :(this.models('props.data.nsetup.consignment_category.code')=='B' && mailclass_concat!='T')?<a href={trans('/cn41?id=:id', {id:this.props.data.id})} target="_blank" className="btn btn-beige w-25 text-light">CN 41</a>
                            :(this.models('props.data.nsetup.consignment_category.code')=='B' && mailclass_concat=='T')?<button href={trans('/cn41?id=:id', {id:this.props.data.id})} type="button" className="btn btn-danger w-25 text-light">CN 47</button>
                            :null}
                            {this.models('props.data.nsetup.csd', []).length>0?<a href={`#dialog/csd?cardit_id=${this.models('props.data.id')}`} target="_blank" className="btn btn-beige w-25 text-light ml-2">CSD</a>:null}
                            {this.models('props.data.receptacles', []).filter(it=>this.cast(it, 'nsetup.poc.mld_type')=='CV' && this.cast(it, 'nsetup.poc.filename')).length>0?<a href={`#dialog/mlds?filename=${this.models('props.data.receptacles', []).find(it=>this.cast(it, 'nsetup.poc.mld_type')=='CV').nsetup.poc.filename}`} target="_blank" className="btn btn-beige w-25 text-light ml-2">MLD</a>:null}
                        </li>
                        
                        <li>
                            {trans('Numéro du container')} :
                            <span>{this.props.data.nsetup.container_id} {this.props.readOnly?<React.Fragment><a href={`#barcode?code=${this.props.data.nsetup.container_id}`} onClick={()=>$(`#uld${this.props.data.nsetup.container_id}`).modal('show')}><i className="fa fa-barcode"></i></a>
                                <Popup id={`uld${this.props.data.nsetup.container_id}`} className="modal-xl">
                                    <PopupBody>
                                        <div className="text-center py-5">
                                            <img src={`/barcode?code=${this.props.data.nsetup.container_id}`}/>
                                        </div>
                                    </PopupBody>
                                </Popup>
                            </React.Fragment>:null}</span>
                        </li>
                        <li>
                            {trans('Container Journey ID')} :
                            <span>{this.props.data.nsetup.cjid}</span>
                        </li>
                        <li>
                            {trans('Nombre de récipient')} :
                            <span>{this.props.data.nsetup.nreceptacles}</span>
                        </li>
                        <Route data={this.props.data}/>
                    </ul>
                </div>
            </div>
            <div className="col-xl-9">
                <div className="table-responsive">
                    <form name={`frm_cardit${this.props.data.id}`} action={`/reception`} method="post">
                        {this.state.dialogs.map((v,k)=><Ry key={`ajaxform-${k}`} title="ajaxform"/>)}
                        <input type="hidden" name="ry"/>
                        <input type="hidden" name="id" value={this.props.data.id}/>
                        <input type="hidden" name="consignment_event" value="reception"/>
                        <table className="table tableRecap">
                            <thead>
                                <tr>
                                    <th rowSpan="2" colSpan="6"
                                        className="colorVert noBor pl-0 text-left text-wrap">
                                        <div className="row text-dark text-center font-weight-normal">
                                            <h6 className="ml-4">Nombre de sacs scannés : <strong>{numberScannedBags} </strong></h6>
                                            <h6 className="ml-4">Poids total scanné : <strong>{numeral(weightScannedBags).format('0.00')} Kg</strong></h6>
                                        </div>
                                    </th>
                                    <th colSpan={this.props.consignmentEvents.length} className="thTop">{trans('POC')}</th>
                                </tr>
                                <tr className="thLeft">
                                    {this.props.consignmentEvents.map(consignment_event=><th key={`consignment_event-${consignment_event.code}`}>{trans(consignment_event.trans_interpretation)}</th>)}
                                </tr>
                                <tr>
                                    <th width="300">{trans('Numéro du récipient')}</th>
                                    <th>{trans('Type')}</th>
                                    <th width="250">{trans('ULD IN')}</th>
                                    <th width="250">{trans('ULD OUT')}</th>
                                    <th>{trans('Type de récipient')}</th>
                                    <th>{trans('Poids (Kg)')}</th>
                                    {this.props.consignmentEvents.map(consignment_event=><th key={`consignment_event-checkall-${consignment_event.code}`} width="10%">
                                        <label className="fancy-radio custom-color-green m-auto">
                                            <input type="radio" name="checkall[status]" onChange={()=>this.handleAllReceptacleStatusChange(consignment_event.code)}/>
                                            <span><i className="m-0"></i></span>
                                        </label>
                                    </th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.receptacles.map((receptacle, index)=><ReceptacleLine key={`content-reception-${receptacle.id}`} data={receptacle} messageFunction={this.models('props.data.nsetup.message_function')} readOnly={this.props.readOnly} consignmentEvents={this.props.consignmentEvents} handleReceptacleStatusChange={code=>this.handleReceptacleStatusChange(receptacle, code)} impcs={this.props.impcs}/>)}
                                <tr>
                                    <td colSpan="6" className="border-right-0 noBg"></td>
                                    <td colSpan={this.props.consignmentEvents.length} className="border-left-0 border-right-0 p-0">
                                        {(this.state.dirty && this.state.showModal)?<button className="btn btn-orange rounded-0" type="button" onClick={this.selectUld}>{trans('Valider')}</button>:null}
                                        {(this.state.dirty && this.state.showModal == false && this.state.alltreated == false)?<button className="btn btn-orange rounded-0" type="submit">{trans('Valider')}</button>:null}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <Popup id={`select-uld-${this.props.data.id}`}>
                            <PopupHeader>
                                {trans("POC Confirmation")}
                            </PopupHeader>
                            <PopupBody>
                                <div className="form-group">
                                    <label className="control-label">
                                        {trans('Nº de conteneur')}
                                    </label>
                                    <input type="text" name="container_id" className="form-control bs-default" required defaultValue={this.props.data.container_id}/>
                                </div>
                                <button className="btn btn-beige text-light py-2 mt-3">{trans('Valider')}</button>
                            </PopupBody>
                        </Popup>
                        <Localtime/>
                    </form>
                </div>
            </div>
        </div>
    }
}

export default Modelizer(Reception);